import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getdatanoauth } from "../../util/global";
import { locationitem } from './Datatype';

const ReveenHome = () => {
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [result, setResult] = useState('');

  const handleCheck = async (e: React.FormEvent) => {
    e.preventDefault();
    const zones = await getdatanoauth({ filter: { datatype: "locationdata" } });
    const zone = zones.find((z: locationitem) =>
      z.status === 'open' && z.pins.split(',').map(p => p.trim()).includes(pin)
    );
    if (zone) navigate('/shop');
    else setResult('We are not in your area yet, coming soon');
  };

  return (
    <div className="page-card" style={{ maxWidth: '440px', margin: '3rem auto' }}>
      <div className="eyebrow">STEP 01</div>
      <h2 style={{ fontFamily: 'var(--display)', fontSize: '1.9rem', fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 20px' }}>Check serviceability.</h2>
      <form onSubmit={handleCheck}>
        <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Pin Code</label>
          <input
            type="text"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn-blue" style={{ width: '100%' }}>Check</button>
      </form>
      {result && <div style={{ marginTop: '1.25rem', fontSize: '0.85rem', textAlign: 'center', color: 'var(--cust-muted)' }}>{result}</div>}
    </div>
  );
};

export default ReveenHome;
